import { getUserDetails } from './cabsLandingAPIs';

const getCookie = () => {
  return typeof document !== 'undefined' ? document.cookie : null;
};
const isUserLoggedIn = () => {
  const cookie = getCookie();
  if (cookie) {
    const mmtAuth = cookie.match('mmt-auth');
    return Promise.resolve(!!mmtAuth);
  }
  return null;
};

const getCookieValue = key => {
  const cookieValue = getCookie();
  if (cookieValue == null) return null;

  return cookieValue
    .split('; ')
    .find(row => row.startsWith(`${key}=`))
    ?.split('=')[1];
};

export const getMmtAuth = () => {
  try {
    const cookie = getCookie();
    if (cookie) {
      const mmtAuth = getCookieValue('mmt-auth');
      if (mmtAuth) {
        return mmtAuth;
      }
    }
  } catch (ex) {
    console.error('Exception in getMmtAuth', ex);
  }
  return null;
};

export const fetchUserDetails = async () => {
  try {
    const mmtAuth = getMmtAuth();
    if (mmtAuth) {
      const userData = await getUserDetails(mmtAuth);
      return userData;
    }
    return null;
  } catch (ex) {
    console.error('Exception in fetchUserDetails', ex);
  }
};
